import { HumanNonBinaryIcon } from './HumanNonBinaryIcon';

/**
 * author: Michael Irigoyen
 * id 0993FCF5-5C89-4F54-ABFC-310CDF2AED15
 * name human-non-binary
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-non-binary.svg
 * tags
 * - People / Family 
 */
export const HumanTransgenderIcon = HumanNonBinaryIcon;
export default HumanTransgenderIcon